import { render, staticRenderFns } from "./DeathReasonTrendChart.vue?vue&type=template&id=454e24b4"
import script from "./DeathReasonTrendChart.vue?vue&type=script&lang=js"
export * from "./DeathReasonTrendChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports